"use client";

import React from "react";
import { Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function QuickLinksMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div data-section-id="103113" className="h-5 w-24 bg-muted/20 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors">
            Domů
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/ServicesPage" className="text-muted-foreground hover:text-primary transition-colors">
            Služby
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/ContactPage" className="text-muted-foreground hover:text-primary transition-colors">
            Kontakt
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function GlobalFooter() {
  return <section id="footer" className="dark bg-background text-foreground border-t border-border/30">
      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/nexo_tech_logo_with_gauges.png" alt="NEXO TECH" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm font-sans">
              Precizní HVAC inženýring a servis. Dodáváme vysoce výkonné systémy řízení klimatu a specializovanou technickou podporu pro průmyslovou a moderní infrastrukturu.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-bold mb-6 text-foreground tracking-tight uppercase">
              Rychlé odkazy
            </h3>
            <MenuProvider menu_id="47">
              <QuickLinksMenu />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-bold mb-6 text-foreground tracking-tight uppercase">
              Technická podpora
            </h3>
            <ul className="space-y-4 text-muted-foreground text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 text-secondary shrink-0 mt-0.5" />
                <span>Provoz NEXO TECH, 1024 Precision Way, Průmyslová čtvrť, TX 75001</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 text-secondary shrink-0" />
                <span>+1 (800) NEXO-TECH</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 text-secondary shrink-0" />
                <span>support@nexotech.com</span>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border/20 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-muted-foreground text-xs font-mono text-center md:text-left tracking-wide">
            &copy; {new Date().getFullYear()} NEXO TECH. VŠECHNA PRÁVA VYHRAZENA. STAV SYSTÉMU: <span className="text-emerald-500 animate-pulse">OPTIMÁLNÍ</span>
          </p>
          <div className="flex items-center gap-5">
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}